export default function displayValue(value, enums, key_field = 'value', value_field = 'name') {
    const item = enums.find(obj => obj[key_field] === value);
    return item ? item[value_field] : '';
}
